import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { concatMap, map, switchMap } from 'rxjs/operators';

import { UserService } from 'ish-core/services/user/user.service';
import { displayErrorMessage } from 'ish-core/store/core/messages/messages.actions';
import { deleteBasketItems } from 'ish-core/store/customer/basket';
import { loginUserSuccess } from 'ish-core/store/customer/user';
import { ApiTokenService } from 'ish-core/utils/api-token/api-token.service';
import { mapErrorToAction, mapToPayload } from 'ish-core/utils/operators';

import { SalesrepService } from '../../services/salesrep.service';

import { loadCustomerByAPIToken, salesRepActions } from './salesrep.actions';

@Injectable()
// eslint-disable-next-line ish-custom-rules/project-structure
export class SalesRepEffects {
  constructor(
    private actions$: Actions,
    private salesRepService: SalesrepService,
    private userService: UserService,
    private apiTokenService: ApiTokenService,
    private store: Store
  ) {}

  switchCustomer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(salesRepActions.switchCustomer),
      mapToPayload(),
      concatMap(({ customerID }) =>
        this.salesRepService.switchSalesRepCustomer(customerID).pipe(
          map(() => salesRepActions.switchCustomerSuccess()),
          mapErrorToAction(salesRepActions.switchCustomerFail)
        )
      )
    )
  );

  switchCustomerSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(salesRepActions.switchCustomerSuccess),
        map(() => {
          this.store.dispatch(deleteBasketItems());
          window.location.reload();
        })
      ),
    { dispatch: false }
  );

  loadCustomerByApiTokens$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCustomerByAPIToken),
      concatLatestFrom(() => this.apiTokenService.apiToken$),
      switchMap(([, apiToken]) =>
        this.userService
          .signInUserByToken(apiToken)
          .pipe(
            switchMap(customer =>
              customer
                ? [salesRepActions.switchCustomerSuccess(), loginUserSuccess(customer)]
                : [salesRepActions.switchCustomerFail()]
            )
          )
      )
    )
  );

  switchCustomerFail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(salesRepActions.switchCustomerFail),

      map(() =>
        displayErrorMessage({
          message: 'dias.sales_rep.switch.fail.text',
        })
      )
    )
  );
}
